import { Component } from '@angular/core';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { environment } from 'src/environments/environment';
import { HealthFirstService } from '../../services/health-first.service';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'src/app/common/button/button.module';

@Component({
  selector: 'app-hf-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    ButtonModule
  ],
  templateUrl: './hf-header.component.html',
  styleUrls: ['./hf-header.component.scss']
})
export class HfHeaderComponent {
  constructor(
    public util: UtilService,
    private vars: VariablesService,
    private hfService: HealthFirstService,
    private router: Router,
    private events: EventsService
  ) {
    this.subs.push(this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd && typeof window !== 'undefined') {
          this.isThankyouPage = window.location.pathname.split('?')[0] === '/healthfirst/thankyou';
          this.isPlans = window.location.pathname.split('?')[0] === '/healthfirst/plans';
          this.hideHeader = this.hideHeaderOn.includes(window.location.pathname.split('?')[0]);
        }
      })
    );
  }
  subs = [];
  isLoggedIn;
  showUserIcon = false;
  userData;
  environment = environment
  isThankyouPage = false;
  isPlans = false;
  hideHeaderOn = ['/healthfirst/calculator', '/healthfirst/risk-meter'];
  hideHeader = false;

  ngOnInit() {
    this.checkUserLogin();
    if (typeof window !== 'undefined') {
      this.isThankyouPage = window.location.pathname.split('?')[0] === '/healthfirst/thankyou';
      this.isPlans = window.location.pathname.split('?')[0] === '/healthfirst/plans';
      this.hideHeader = this.hideHeaderOn.includes(window.location.pathname.split('?')[0]);
    }
  }

  checkUserLogin() {
    this.onLoggedInUser();
    this.util.isLoggedIn.subscribe((res) => {
      this.isLoggedIn = res;
    });
  }

  onLoggedInUser() {
    this.vars.userData.subscribe({
      next: (res) => {
        this.userData = res;
        if (res) {
          this.isLoggedIn = true;
        }
        this.showUserIcon = res && res.avtar && res.avtar.cdn_path ? false : true;
      }
    });
  }

  onLoginClick() {
    this.events.sendSystemEvent({
      eventName: 'login',
      info_2: 'header'
    }).subscribe(_ => _);
    this.events.claverTapPush('Healthfirst login', {
      'Event Name': 'login',
      'info_2': 'header'
    })
    this.router.navigate(['/new/signin'], {queryParams: { redirect_uri: this.router.url.split('?')[0], id: environment.health_first_campaign_id, vendor: 'medibuddy', loginType: 'header'}})
  }

  onPlanClick() {
    this.events.sendSystemEvent({
      eventName: 'find_my_plan',
      info_2: 'header'
    }).subscribe(_ => _);
    this.events.claverTapPush('Healthfirst find my plan', {
      'Event Name': 'find_my_plan',
      'info_2': 'header'
    });
    this.hfService.selectedBenefit = null;
    this.router.navigate(['/healthfirst/plans']);
  }
}
